import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["select"]

  change() {
    const category = this.selectTarget.value
    this.element.querySelectorAll("[data-filter-category-id]").forEach(el => {
      if (el.dataset.filterCategoryId === category) {
        el.classList.remove("d-none")
      } else {
        el.classList.add("d-none")
        el.querySelectorAll("input").forEach(input => {
          input.value = "";
        });
      }
    });
  }
}
